import { Icon, Button } from "semantic-ui-react";

const isLinkPublic = (link) => {
  const now = new Date();
  if (!link.isActive) return false;
  if (link.validFrom && new Date(link.validFrom) > now) return false;
  if (link.validUntil && new Date(link.validUntil) < now) return false;
  return true;
};

const LinktreePreview = ({
  title,
  subtitle,
  links = [],
  backgroundImage,
  logoImage,
}) => {
  const styles = {
    phoneFrame: {
      width: "360px",
      height: "720px",
      borderRadius: "40px",
      backgroundColor: "#043458",
      padding: "12px",
      boxShadow: "0 20px 40px rgba(25, 25, 112,0.3)",
      margin: "0 auto",
    },

    screen: {
      width: "100%",
      height: "100%",
      borderRadius: "28px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      overflow: "hidden",
    },

    content: {
      padding: "2rem 1.5rem 1rem",
      textAlign: "center",
    },

    logoWrapper: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "1rem",
    },

    logo: {
      width: "96px",
      height: "96px",
      borderRadius: "50%",
      objectFit: "cover",
      border: "4px solid white",
      backgroundColor: "#fff",
    },

    title: {
      margin: "0.5rem 0 0",
      fontSize: "1.6rem",
      fontWeight: "700",
      color: "#fff",
    },

    subtitle: {
      margin: "0.25rem 0 1.5rem",
      fontSize: "1rem",
      color: "rgba(255,255,255,0.85)",
    },

    links: {
      display: "flex",
      flexDirection: "column",
      gap: "0.75rem",
    },

    linkButton: {
      borderRadius: "999px",
      backgroundColor: "#fff",
      fontWeight: "600",
    },

    footer: {
      display: "flex",
      justifyContent: "center",
      gap: "1.5rem",
      padding: "1rem",
      color: "#fff",
    },

    socialIconStyle: {
      background: "rgba(0,0,0,0.35)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      color: "#c39d63",
      boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.phoneFrame}>
      <div
        style={{
          ...styles.screen,
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div style={styles.content}>
          <div style={styles.logoWrapper}>
            <img src={logoImage} alt="Logo" style={styles.logo} />
          </div>

          <h2 style={styles.title}>{title}</h2>
          <p style={styles.subtitle}>{subtitle}</p>

          <div style={styles.links}>
            {links.filter(isLinkPublic).map((link) => (
              <Button
                key={link.id}
                fluid
                size="large"
                style={styles.linkButton}
              >
                {link.icon && <Icon name={link.icon} />}
                {link.name}
              </Button>
            ))}
          </div>
        </div>

        <div style={styles.footer}>
          <Icon size='big' link circular name='instagram' style={styles.socialIconStyle}/>
          <Icon size='big' link circular name='facebook f' style={styles.socialIconStyle}/>
        </div>
      </div>
    </div>
  );
};

export default LinktreePreview;
